import { GetNameOnEnvelopeUsageOptions, NameOnEnvelopeEventName } from '../analytics-context-types';
import { getModalTag, getPODProductTag } from './utils';

const level2ByEventName: Record<NameOnEnvelopeEventName, string> = {
  'return-address': 'Address the Envelope - Sender',
  'recipient-address': 'Address the Envelope - Recipient',
  'edit-address': 'Address Book - Edit Address',
};

export const getNameOnEnvelopeUsageTag = (options: GetNameOnEnvelopeUsageOptions) => {
  if (
    !Object.prototype.hasOwnProperty.call(level2ByEventName, options?.eventName) ||
    typeof options?.isPopulated !== 'boolean' ||
    typeof options.productName !== 'string' ||
    typeof options.productID !== 'string' ||
    typeof options.productType !== 'string' ||
    typeof options.projectID !== 'string' ||
    typeof options.productQuantity !== 'string'
  ) {
    throw new Error('Invalid Name on Envelope usage tag options');
  }

  const event = [
    {
      eventInfo: {
        eventName: options.eventName,
        eventAction: options.isPopulated ? 'name-on-envelope-populated' : 'name-on-envelope-not-populated',
      },
    },
  ];
  const level2 = level2ByEventName[options.eventName];
  const { modal, user } = getModalTag(options.productType, level2, event, options.projectID);
  const { product } = getPODProductTag(
    options.productName,
    options.productID,
    options.productType,
    options.productQuantity,
  );

  return { modal, product, user };
};
